import React, {useEffect, useState} from 'react';
import {Offer} from "types/Offer";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";

type Props = {
    offer: Offer | null
    show: boolean
    onDelete?: (offer: Offer) => any
    onDeleteFail?: (offer: Offer, error: unknown) => any
    onCancel?: () => any
}

function DeleteOffer(props: Props) {
    const {offer, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(offer?.name || 'this offer');
    const {mutateAsync: deleteOffer} = useMutation(ngage.offers.destroy)

    useEffect(() => {
        if(offer) setName(offer.name)
    }, [offer]);

    async function handleDeleteOffer() {
        if (offer) {
            try {
                await deleteOffer(offer.id)
                await invalidate('offers.all')

                if (onDelete) onDelete(offer)
            } catch (error) {
                if (onDeleteFail) onDeleteFail(offer, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Offer"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteOffer}
            onCancel={handleCancel}
        />
    );
}

export default DeleteOffer;